export enum ValueFormatType {
	TYPE_TEXT = 'text',
	TYPE_NUMBER = 'number'
}

interface ValueFormat {
	type: 'text' | 'number';
}

export interface ValueFormatText extends ValueFormat {
	length: number;
}

export interface ValueFormatNumber extends ValueFormat {
	lengthInteger: number;
	decimalCount: number;
	min?: number;
	max?: number;
}
